import { BaseModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { ImageService } from '~/services/Misc/ImageService'

export default class CareerRoutesDetailVideoItemModel extends BaseModel {
  name: string = ''
  link: string = ''
  image: string = ''

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (data.image) {
        this.image = new ImageService().cropImage(data.image, {})
      }
    }
  }
}
